// ======================================================================
// FILE:
// src/modules/service_crm/visits/components/VisitDrawer.js
//
// MODULE:
// Service CRM
//
// FEATURE:
// Service Visit Drawer
// ======================================================================

import React, {
  useEffect,
  useState,
} from "react";

import serviceTicketService
from "../../services/serviceTicketService";

export default function VisitDrawer({

  open,

  mode = "view",

  ticket,

  onClose,

  onSaved,

}) {

  const [loading, setLoading] =
    useState(false);

  const [visits, setVisits] =
    useState([]);

  const [saving, setSaving] =
    useState(false);

  const [form, setForm] =
    useState({

      engineer_name: "",

      running_hours: "",

      work_done: "",

      observations: "",

      parts_used: "",

      next_visit_required: false,

    });

    const [showCompleteVisitModal, setShowCompleteVisitModal] =
  useState(false);

const [selectedVisitId, setSelectedVisitId] =
  useState(null);

const [completionForm, setCompletionForm] =
  useState({

    running_hours: "",

    work_done: "",

    observations: "",

    parts_used: "",

    status_after_visit: "",

    next_visit_required: false,

  });

  // ==========================================================
  // LOAD VISITS
  // ==========================================================

  useEffect(() => {

    if (
      open &&
      ticket
    ) {

      loadVisits();

    }

  }, [open, ticket]);

  async function loadVisits() {

    try {

      setLoading(true);

      const rows =
        await serviceTicketService
          .listVisits(
            ticket.ticket_id
          );

      setVisits(
        rows || []
      );

    } catch (err) {

      console.error(err);

    } finally {

      setLoading(false);

    }

  }

  // ==========================================================
  // FORM
  // ==========================================================

  function handleChange(
    field,
    value
  ) {

    setForm((prev) => ({

      ...prev,

      [field]: value,

    }));

  }

  // ==========================================================
  // SAVE
  // ==========================================================

  async function saveVisit() {

    try {

      if (
        !form.engineer_name
      ) {

        alert(
          "Engineer is required"
        );

        return;
      }

      setSaving(true);

      await serviceTicketService
        .addVisit(

          ticket.ticket_id,

          form

        );

      alert(
        "Visit added successfully"
      );

      setForm({

        engineer_name: "",

        running_hours: "",

        work_done: "",

        observations: "",

        parts_used: "",

        next_visit_required: false,

      });

      await loadVisits();

      if (onSaved) {

        onSaved();

      }

    } catch (err) {

      console.error(err);

      alert(
        "Failed to save visit"
      );

    } finally {

      setSaving(false);

    }

  }

  
  
  async function getCurrentLocation() {

  return new Promise(
    (resolve, reject) => {

      if (!navigator.geolocation) {

        reject(
          new Error(
            "Geolocation not supported"
          )
        );

        return;
      }

      navigator.geolocation.getCurrentPosition(

        (position) => {

          resolve({

            latitude:
              position.coords.latitude,

            longitude:
              position.coords.longitude,

          });

        },

        (error) => {

          reject(error);

        },

        {
          enableHighAccuracy: true,
          timeout: 15000,
          maximumAge: 0,
        }

      );

    }
  );

}

async function handleStartVisit(
  visitId
) {

  try {

    const location =
      await getCurrentLocation();

    await serviceTicketService
      .startVisit(
        visitId,
        location
      );

    await loadVisits();

    if (onSaved) {

      onSaved();

    }

    alert(
      "Visit started successfully"
    );

  } catch (err) {

    console.error(err);

    alert(
      err?.response?.data?.message ||
      "Unable to start visit"
    );

  }

}
async function handleCompleteVisit() {

  try {

    if (
      !completionForm.running_hours
    ) {

      alert(
        "Running Hours is required"
      );

      return;
    }

    if (
      !completionForm.work_done
    ) {

      alert(
        "Work Done is required"
      );

      return;
    }

    const location =
      await getCurrentLocation();

    await serviceTicketService
      .stopVisit(

        selectedVisitId,

        {

          ...location,

          running_hours:
            completionForm.running_hours,

          work_done:
            completionForm.work_done,

          observations:
            completionForm.observations,

          parts_used:
            completionForm.parts_used,

          status_after_visit:
            completionForm.status_after_visit,

          next_visit_required:
            completionForm.next_visit_required,

        }

      );

    setShowCompleteVisitModal(
      false
    );

    setSelectedVisitId(
      null
    );

    setCompletionForm({

      running_hours: "",

      work_done: "",

      observations: "",

      parts_used: "",

      status_after_visit: "",

      next_visit_required: false,

    });

    await loadVisits();

    if (onSaved) {

      onSaved();

    }

    alert(
      "Visit completed successfully"
    );

  } catch (err) {

    console.error(err);

    alert(

      err?.response?.data?.message ||

      "Unable to complete visit"

    );

  }

}
async function handleStopVisit(
  visitId
) {

  try {

    const location =
      await getCurrentLocation();

    await serviceTicketService
      .stopVisit(
        visitId,
        location
      );

    await loadVisits();

    if (onSaved) {

      onSaved();

    }

    alert(
      "Visit completed successfully"
    );

  } catch (err) {

    console.error(err);

    alert(
      err?.response?.data?.message ||
      "Unable to stop visit"
    );

  }

}
  if (
    !open ||
    !ticket
  ) {

    return null;

  }

  const renderCompleteVisitModal = () => {

  if (!showCompleteVisitModal) {

    return null;

  }

  return (

    <div className="modal-backdrop">

      <div
        className="card"
        style={{
          width: 700,
          maxWidth: "95%",
          padding: 20,
          margin: "40px auto"
        }}
      >

        <h5>
          Complete Visit
        </h5>

        <div className="row">

          <div className="col-md-6">

            <label>
              Running Hours *
            </label>

            <input
              type="number"
              className="form-control"
              value={
                completionForm.running_hours
              }
              onChange={(e) =>
                setCompletionForm({
                  ...completionForm,
                  running_hours:
                    e.target.value
                })
              }
            />

          </div>

          <div className="col-md-6">

            <label>
              Status After Visit
            </label>

            <input
              type="text"
              className="form-control"
              value={
                completionForm.status_after_visit
              }
              onChange={(e) =>
                setCompletionForm({
                  ...completionForm,
                  status_after_visit:
                    e.target.value
                })
              }
            />

          </div>

        </div>

        <div className="mt-3">

          <label>
            Work Done *
          </label>

          <textarea
            rows={4}
            className="form-control"
            value={
              completionForm.work_done
            }
            onChange={(e) =>
              setCompletionForm({
                ...completionForm,
                work_done:
                  e.target.value
              })
            }
          />

        </div>

        <div className="mt-3">

          <label>
            Observations
          </label>

          <textarea
            rows={3}
            className="form-control"
            value={
              completionForm.observations
            }
            onChange={(e) =>
              setCompletionForm({
                ...completionForm,
                observations:
                  e.target.value
              })
            }
          />

        </div>

        <div className="mt-3">

          <label>
            Parts Used
          </label>

          <textarea
            rows={3}
            className="form-control"
            value={
              completionForm.parts_used
            }
            onChange={(e) =>
              setCompletionForm({
                ...completionForm,
                parts_used:
                  e.target.value
              })
            }
          />

        </div>

        <div className="form-check mt-3">

          <input
            type="checkbox"
            className="form-check-input"
            checked={
              completionForm.next_visit_required
            }
            onChange={(e) =>
              setCompletionForm({
                ...completionForm,
                next_visit_required:
                  e.target.checked
              })
            }
          />

          <label
            className="form-check-label"
          >
            Next Visit Required
          </label>

        </div>

        <div
          className="mt-4 d-flex gap-2"
        >

          <button
            className="btn btn-secondary"
            onClick={() =>
              setShowCompleteVisitModal(
                false
              )
            }
          >
            Cancel
          </button>

          <button
            className="btn btn-primary"
            onClick={
              handleCompleteVisit
            }
          >
            Complete Visit
          </button>

        </div>

      </div>

    </div>
  );
};
  // ==========================================================
  // UI
  // ==========================================================

  return (

    <>

      {/* BACKDROP */}

      <div

        onClick={onClose}

        style={{

          position: "fixed",

          top: 0,

          left: 0,

          right: 0,

          bottom: 0,

          background:
            "rgba(0,0,0,0.45)",

          zIndex: 999,

        }}

      />

      {/* DRAWER */}

      <div

        style={{

          position: "fixed",

          top: 0,

          right: 0,

          width: "950px",

          maxWidth: "95vw",

          height: "100vh",

          background: "#fff",

          overflowY: "auto",

          zIndex: 1000,

          boxShadow:
            "-2px 0 12px rgba(0,0,0,0.15)",

        }}

      >

        {/* HEADER */}

        <div

          style={{

            padding: 20,

            borderBottom:
              "1px solid #dee2e6",

            display: "flex",

            justifyContent:
              "space-between",

            alignItems:
              "center",

          }}

        >

          <div>

            <h4
              style={{
                margin: 0,
              }}
            >

              Service Visits

            </h4>

            <div
              style={{
                color: "#6c757d",
              }}
            >

              {ticket.ticket_no}

            </div>

          </div>

          <button

            className="
btn btn-outline-secondary"

            onClick={
              onClose
            }

          >

            Close

          </button>

        </div>

        {/* TICKET SUMMARY */}

        <div
          className="p-3"
        >

          <div className="row">

            <div className="col-md-3">

              <div className="card">

                <div className="card-body">

                  <small>
                    Ticket No
                  </small>

                  <div>
                    <b>
                      {
                        ticket.ticket_no
                      }
                    </b>
                  </div>

                </div>

              </div>

            </div>

            <div className="col-md-3">

              <div className="card">

                <div className="card-body">

                  <small>
                    Customer
                  </small>

                  <div>
                    <b>
                      {
                        ticket.customer_name
                      }
                    </b>
                  </div>

                </div>

              </div>

            </div>

            <div className="col-md-3">

              <div className="card">

                <div className="card-body">

                  <small>
                    Engineer
                  </small>

                  <div>
                    <b>
                      {
                        ticket.assigned_engineer
                      }
                    </b>
                  </div>

                </div>

              </div>

            </div>

            <div className="col-md-3">

              <div className="card">

                <div className="card-body">

                  <small>
                    Status
                  </small>

                  <div>
                    <b>
                      {
                        ticket.status
                      }
                    </b>
                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

        {/* ADD VISIT */}

        {mode !== "view" && (

          <div className="p-3">

            <div className="card">

              <div className="card-header">

                Add Visit

              </div>

              <div className="card-body">

                <div className="row g-3">

                  <div className="col-md-6">

                    <label>
                      Service Provider
                    </label>

                    <input
                      className="form-control"
                      value={
                        form.engineer_name
                      }
                      onChange={(e) =>
                        handleChange(
                          "engineer_name",
                          e.target.value
                        )
                      }
                    />

                  </div>

                  <div className="col-md-6">

                    <label>
                      Running Hours
                    </label>

                    <input
                      className="form-control"
                      value={
                        form.running_hours
                      }
                      onChange={(e) =>
                        handleChange(
                          "running_hours",
                          e.target.value
                        )
                      }
                    />

                  </div>

                  <div className="col-md-12">

                    <label>
                      Work Done
                    </label>

                    <textarea
                      rows="3"
                      className="form-control"
                      value={
                        form.work_done
                      }
                      onChange={(e) =>
                        handleChange(
                          "work_done",
                          e.target.value
                        )
                      }
                    />

                  </div>

                  <div className="col-md-12">

                    <label>
                      Observations
                    </label>

                    <textarea
                      rows="3"
                      className="form-control"
                      value={
                        form.observations
                      }
                      onChange={(e) =>
                        handleChange(
                          "observations",
                          e.target.value
                        )
                      }
                    />

                  </div>

                  <div className="col-md-12">

                    <label>
                      Parts Used
                    </label>

                    <textarea
                      rows="2"
                      className="form-control"
                      value={
                        form.parts_used
                      }
                      onChange={(e) =>
                        handleChange(
                          "parts_used",
                          e.target.value
                        )
                      }
                    />

                  </div>

                  <div className="col-md-12">

                    <div className="form-check">

                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={
                          form.next_visit_required
                        }
                        onChange={(e) =>
                          handleChange(
                            "next_visit_required",
                            e.target.checked
                          )
                        }
                      />

                      <label
                        className="
form-check-label"
                      >
                        Next Visit Required
                      </label>

                    </div>

                  </div>

                </div>

                <div
                  className="mt-3"
                >

                  <button

                    className="
btn btn-primary"

                    onClick={
                      saveVisit
                    }

                    disabled={
                      saving
                    }

                  >

                    {saving
                      ? "Saving..."
                      : "Save Visit"}

                  </button>

                </div>

              </div>

            </div>

          </div>

        )}

        {/* VISIT HISTORY */}

        <div className="p-3">

          <div className="card">

            <div className="card-header">

              Visit History

            </div>

            <div className="card-body">

              {loading && (
                <div>
                  Loading...
                </div>
              )}

              {!loading &&
                visits.length === 0 && (

                <div>
                  No Visits Found
                </div>

              )}

              {!loading &&
                visits.map((visit) => (

                <div

                  key={
                    visit.id
                  }

                  className="
border rounded p-3 mb-3"

                >

                  <div
                    className="d-flex justify-content-between align-items-center"
                  >

                    <div>

                      <b>
                        {
                          visit.visit_no
                        }
                      </b>

                    </div>

                    <span

                      className={

                        visit.visit_status === "COMPLETED"

                          ? "badge bg-success"

                          : visit.visit_status === "IN_PROGRESS"

                          ? "badge bg-warning text-dark"

                          : "badge bg-secondary"

                      }

                    >

                      {
                        visit.visit_status ||
                        "NOT_STARTED"
                      }

                    </span>

                  </div>

                  <div>

                    Visit Date:

                    {" "}

                    {new Date(
                      visit.visit_datetime
                    ).toLocaleString()}

                  </div>

                  <div>

                    Engineer:

                    {" "}

                    {
                      visit.engineer_name
                    }

                  </div>
                  <div>

                    Started:

                    {" "}

                    {

                      visit.visit_start_time

                        ? new Date(
                            visit.visit_start_time
                          ).toLocaleString()

                        : "-"

                    }

                  </div>

                  <div>

                    Stopped:

                    {" "}

                    {

                      visit.visit_end_time

                        ? new Date(
                            visit.visit_end_time
                          ).toLocaleString()

                        : "-"

                    }

                  </div>

                  <div>

                    Duration:

                    {" "}

                    {

                      visit.visit_duration_minutes !== null &&
                      visit.visit_duration_minutes !== undefined

                        ? `${visit.visit_duration_minutes} mins`

                        : "-"

                    }

                  </div>

                  <div>

                    Start Location:

                    {" "}

                    {

                      visit.start_address

                        ? visit.start_address

                        : (

                            visit.start_latitude &&
                            visit.start_longitude

                          )

                          ? `${visit.start_latitude}, ${visit.start_longitude}`

                          : "-"

                    }

                  </div>

                  <div>

                    End Location:

                    {" "}

                    {

                      visit.end_address

                        ? visit.end_address

                        : (

                            visit.end_latitude &&
                            visit.end_longitude

                          )

                          ? `${visit.end_latitude}, ${visit.end_longitude}`

                          : "-"

                    }

                  </div>

                  <div>

                    Running Hours:

                    {" "}

                    {
                      visit.running_hours
                    }

                  </div>

                  <div>

                    Next Visit:

                    {" "}

                    {visit.next_visit_required
                      ? "Yes"
                      : "No"}

                  </div>

                  <hr />

                  <div>

                    <b>
                      Work Done
                    </b>

                    <div>
                      {
                        visit.work_done
                      }
                    </div>

                  </div>

                  <div
                    className="mt-2"
                  >

                    <b>
                      Observations
                    </b>

                    <div>
                      {
                        visit.observations
                      }
                    </div>

                  </div>

                  <div
                    className="mt-2"
                  >

                    <b>
                      Parts Used
                    </b>

                    <div>
                      {
                        visit.parts_used
                      }
                    </div>

                  </div>
                  <hr />

                  <div
                    className="d-flex gap-2"
                  >

                    {

                      visit.visit_status ===
                      "NOT_STARTED" && (

                        <button

                          className="btn btn-success btn-sm"

                          onClick={() =>
                            handleStartVisit(
                              visit.id
                            )
                          }

                        >

                          Start Visit

                        </button>

                      )

                    }

                    {

                      visit.visit_status ===
                      "IN_PROGRESS" && (

                        <button

                        className="btn btn-danger btn-sm"

                        onClick={() => {

                          setSelectedVisitId(
                            visit.id
                          );

                          setShowCompleteVisitModal(
                            true
                          );

                        }}

                      >

                        Stop Visit

                      </button>

                      )

                    }

                  </div>

                </div>

              ))}

            </div>

          </div>

        </div>

      </div>
      {renderCompleteVisitModal()}        
    </>

  );

}